"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userBase = void 0;
const Alignment_1 = require("../../enums/Alignment");
const UserBaseIdentifierType_1 = require("../../enums/game-center/UserBaseIdentifierType");
const FormInputType_1 = require("../../enums/game/FormInputType");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.userBase = {
    isEnable: false,
    identifierType: UserBaseIdentifierType_1.UserBaseIdentifierType.USER_INPUT,
    parameters: [
        {
            type: FormInputType_1.FormInputType.EMAIL,
            placeholder: 'Your e-mail',
            order: 1,
            isIdentifierType: UserBaseIdentifierType_1.UserBaseIdentifierType.USER_INPUT,
            isIdentifier: true,
            internalName: '',
        },
    ],
    loginEmailTitle: 'Welcome to Game Center',
    loginEmailText: 'Welcome to Game Center. Here is your verification code:',
    signUpEmailTitle: 'Welcome',
    signUpEmailText: 'Welcome to Game Center. Please click on the link below to verify your account.',
    loginBackgroundColor: 'FFFFFF',
    loginTextColor: '000000',
    logoImage: (0, game_center_asset_1.getGameCenterAssetUrl)('logo-sign.png'),
    logoAlignment: Alignment_1.Alignment.CENTER,
    loginTermsText: 'I agree to the general Terms & Conditions',
    additionalTermsText: '',
    additionalTerms: [
        {
            terms: '',
            isOptional: true,
            name: 'terms1',
            internalName: 'terms1',
        },
    ],
    stickyText: 'Access Game Center',
    landingPageText: 'Enter your email to play!',
    additionalFormText: 'Please provide additional \ninformation below',
    signInCodeText: 'We have sent a verification code to the email below. Please enter the code to verify your account.',
    signUpVerificationText: 'We have sent a verification email to the email below. Please click on the link in the email to verify your account. ',
};
